import React from 'react';
import { Container, Col, Row, Card, CardHeader, CardBody } from 'reactstrap';
import styles from './Confirmation.module.css';
import { useHistory } from 'react-router-dom';
import BrandedIcon from '../_BrandingProvider/BrandedIcon';
import CryptoJS from 'crypto-js';

const ReimbursementConfirmation = () => {
    const router = useHistory();
    const claimInfo = router.location.state;
    const addressData = router.location.state.reimbursementData;
    const hashValue = CryptoJS.SHA256(claimInfo.claimId + claimInfo.clientId).toString();
    const handleContinue = () => {
        fetch('api/claim/GetClaimSummaryByClaimNumber/' + claimInfo.claimId + '/' + claimInfo.clientId, {
            method: 'get',
            headers: {
                'Site-Req-Auth': hashValue
            }
        })
            .then((res) => res.json())
            .then((data) => {
                let col = data;
                let columndata = col;
                let pathName = '/DetailsOverview';
                columndata.tcf = col.tcfAmount;
                columndata.incidentDate = col.lossDate;
                columndata.claimSetupDateOverview = col.claimSetupDate;
                if (typeof router?.search != 'undefined') {
                    pathName += `?id=${router?.search}`;
                }
                router.push({
                    pathname: pathName,
                    state: {
                        claim: columndata,
                        clientId: claimInfo.clientId
                    }
                });
            });
    };

    return (
        <Container className={styles.confirmContainer}>
            <Card className={styles.onlineConfirmCard}>
                <CardHeader className={styles.cardheader}>
                    <h1 className='h3'>Thank you for submitting your request.</h1>
                </CardHeader>
                <CardBody className='text-center'>
                    <Col>
                        <BrandedIcon
                            client={claimInfo.clientId}
                            iconType={'emailsent'}
                        />
                        <p className={styles.claimNum}>Claim #{claimInfo.claimId}</p>
                        <Col
                            md='10'
                            lg='10'
                            className={styles.apptMessage}
                        >
                            <h2 className='h4'>Food spoilage reimbursement submitted.</h2>
                        </Col>
                        <p className='mb-2'>
                            Please allow up to 7 to 14 business days for our team to review and process your <br />{' '}
                            reimbursement. A reimbursement check will be mailed to:
                        </p>
                        <p className='mb-0'>{addressData.name}</p>
                        <p className='mb-0'>{addressData.address1}</p>
                        {addressData.address2 ? <p className='mb-0'>{addressData.address2}</p> : null}
                        <p>
                            {addressData.city}, {addressData.state} {addressData.zip}{' '}
                        </p>
                        <button
                            className='btnLink mb-2'
                            onClick={handleContinue}
                        >
                            View Claim Details
                        </button>
                    </Col>
                </CardBody>
            </Card>
        </Container>
    );
};
export default ReimbursementConfirmation;
